import $ from "jquery";
/**
 * Move focus to search input when expanding search
 */
$(document).ready(function() {
  $(".navbar-toggler").click(function(event) {
    event.preventDefault();
    $(this)
      .children()
      .toggleClass("fa-bars fa-times");
    $("html").toggleClass("menu-open");
    $(this)
      .next()
      .fadeToggle();

    if ($("html").hasClass("menu-open")) {
      $("#map").fadeOut(500);
    } else {
      $("#map").show();
    }
  });

  $(".main-banner .owl-carousel").owlCarousel({
    items: 1,
    loop: $(".main-banner .item").length > 1,
    margin: 0,
    nav: $(".main-banner .item").length > 1,
    mouseDrag: $(".main-banner .item").length > 1,
    touchDrag: $(".main-banner .item").length > 1,
    dots: false,
    navText: [
      '<i class="fal fa-chevron-left"></i>',
      '<i class="fal fa-chevron-right"></i>'
    ]
  });

  $(".fullwidth-banner .owl-carousel").owlCarousel({
    items: 1,
    loop: $(".fullwidth-banner .item").length > 1,
    margin: 0,
    nav: false,
    mouseDrag: $(".fullwidth-banner .item").length > 1,
    touchDrag: $(".fullwidth-banner .item").length > 1,
    dots: false,
    navText: [
      '<i class="fal fa-chevron-left"></i>',
      '<i class="fal fa-chevron-right"></i>'
    ]
  });

  $(".GalleryOverlay__container > .owl-carousel").owlCarousel({
    items: 1,
    loop: $(".fullwidth-banner .item").length > 1,
    margin: 0,
    nav: false,
    mouseDrag: true,
    touchDrag: true,
    dots: true,
    navText: [
      '<i class="fal fa-chevron-left"></i>',
      '<i class="fal fa-chevron-right"></i>'
    ]
  });

  // Add smooth scrolling to all links
  $("a").on("click", function(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "" && this.hash !== "content") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash

      var hash = decodeURI(this.hash).replace(/([^\w#])/g, "\\$1");
      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top
        },
        800,
        function() {
          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = hash;
        }
      );
      $("#navbarSupportedContent").fadeOut();
    } // End if
  });
});
